import { ComponentSlotStylesPrepared } from '@fluentui/styles';
import { DropdownItemStylesProps } from '../../../teams/components/Dropdown/dropdownItemStyles';
import { DropdownVariables } from '../../../teams/components/Dropdown/dropdownVariables';

export const dropdownItemStyles: ComponentSlotStylesPrepared<DropdownItemStylesProps, DropdownVariables> = {
  root: () => ({
    border: 'none',
  }),
};
